import { MsalContext, useMsal } from "@azure/msal-react";
import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { Console } from "winston/lib/winston/transports";
import { store } from '../../App';

export const msalConfig = {
    auth: {
        clientId: "5cff42e1-b187-4d9f-9cf0-2c094c1c47b3",
        authority: "https://login.microsoftonline.com/b3d43f62-08b9-4548-8469-082c2a4d951e",
        redirectUri: "https://mdmbp-uat.nedschroef.com/",
        validateAuthority: false
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    apiUrl: "https://apim-mdm-uat-01.azure-api.net/mdm-bp",
    "Ocp-Apim-Subscription-Key": "placeholder-check-variable-group",
    system: {
        tokenRenewalOffsetSeconds: 300,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if(containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error('Error', message);
                        return;
                    case LogLevel.Info:
                        // console.info('Info', message);
                        return;
                    case LogLevel.Verbose:
                        // console.debug('Verbose', message);
                        return;
                    case LogLevel.Warning:
                        console.warn('Warning', message);
                        return;
                }
            }
        }
    }

};
export const msalInstance = new PublicClientApplication(msalConfig);

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [
        "User.Read", 
        "api://5cff42e1-b187-4d9f-9cf0-2c094c1c47b3/app.access"
    ] 
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
export const imageConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};

export const notificationPollingRate = "<NOTIFICATION_POLLING_RATE>";

const tokenRequest = {
    scopes: loginRequest.scopes,
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};
